
import platform from "platform";
export const getUniqueId = (): string => {
  // Generate a pseudo-unique identifier based on user agent and screen dimensions
  const uniqueId = `${navigator.userAgent}-${window.screen.width}x${window.screen.height}`;
  return uniqueId;
};

export const getDeviceName = (): string => {
  // Use navigator.userAgent to get information about the browser
  const userAgent = navigator.userAgent;

  // Detect the browser name based on the userAgent string
  let browserName: string;

  if (userAgent.indexOf("Firefox") !== -1) {
    browserName = "Mozilla Firefox";
  } else if (userAgent.indexOf("Chrome") !== -1) {
    browserName = "Google Chrome";
  } else if (userAgent.indexOf("Safari") !== -1) {
    browserName = "Apple Safari";
  } else if (userAgent.indexOf("Edge") !== -1) {
    browserName = "Microsoft Edge";
  } else if (
    userAgent.indexOf("MSIE") !== -1 ||
    userAgent.indexOf("Trident/") !== -1
  ) {
    browserName = "Internet Explorer";
  } else {
    browserName = "Unknown Browser";
  }

  return browserName;
};

export const getOperatingSystem = () => {
  // Get the operating system from the platform module
   
    let os = platform.os;

    return os;
  
};

export const getDeviceInfo = () => {
  return {
    uniqueId: getUniqueId(),
    deviceName: getDeviceName(),
    operatingSystem: getOperatingSystem()
  };
};